import { InlineWidget } from 'react-calendly';

export function Calendly() {
  return (
    <InlineWidget url="https://calendly.com/boyanaachovski/30min" styles={{ height: '1400px' }} />
  );
}
